import { create } from 'zustand'

// Small shared UI state that needs to cross component boundaries — e.g. the
// game-screen players/settings panel toggle lives in the global header
// (Layout.jsx) but the panel itself renders in GamePage.jsx.
export const useUIStore = create((set) => ({
  gamePanelExpanded: false,
  toggleGamePanel: () => set((state) => ({ gamePanelExpanded: !state.gamePanelExpanded })),
  setGamePanelExpanded: (value) => set({ gamePanelExpanded: value }),

  // Game-specific info panel (e.g. OT's "How to Play"): toggled from the
  // global header menu, rendered by the game plugin. `gameControlsAvailable`
  // is flipped on by a plugin on mount so the menu only offers the item for
  // games that actually register one.
  gameControlsOpen: false,
  toggleGameControls: () => set((state) => ({ gameControlsOpen: !state.gameControlsOpen })),
  setGameControlsOpen: (value) => set({ gameControlsOpen: value }),
  gameControlsAvailable: false,
  setGameControlsAvailable: (value) => set({ gameControlsAvailable: value }),

  // Rendered height of the global header (Layout.jsx), kept live via
  // ResizeObserver — the header wraps to 1-3 lines depending on breakpoint
  // and game-specific content, so anything that needs to sit "just below
  // the header" (toasts, BotActionBanner) reads this instead of a fixed
  // pixel guess.
  headerHeight: 64,
  setHeaderHeight: (value) => set({ headerHeight: value }),

  // A game can have its OWN second header row below the global one (e.g.
  // Red Sea's title/turn/moves bar). Toasts that need to clear it (rather
  // than just the global header) read this instead when it's set. Cleared
  // back to null on unmount so other pages fall back to headerHeight.
  gameSubHeaderBottom: null,
  setGameSubHeaderBottom: (value) => set({ gameSubHeaderBottom: value }),
}))
